import React from 'react';
import Modal from '../utils/Modal/Modal';

const ConfirmDeleteDialog = ({ show, onClose, confirm, message }) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      title="Confirm Delete"
      size="dialog"
      showActions={true}
      confirmLabel="Delete"
      confirmColor="#EF4444"
      cancelLabel="Cancel"
      onConfirm={confirm}
    >
      <div style={{ marginBottom: 24 }}>
        {message || 'Are you sure you want to delete this item?'}
      </div>
    </Modal>
  );
};

export default ConfirmDeleteDialog;
